module.exports = __webpack_public_path__ + "f38997cf5d90f3801b3651c4356ada26.mp4";